import { render } from "./CheckoutNavigation.vue?vue&type=template&id=4af4c42b"
import script from "./CheckoutNavigation.vue?vue&type=script&lang=js"
export * from "./CheckoutNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__